import { wrap as CLWrap } from 'comlink'
import { ajaxUrl } from '../../helpers'

const _worker = new Worker(`${window.getRoute('workers')}fetcher-worker.js`)

/**
 *
 * @type {{
 *     fetch: (url: string) => Promise<unknown>,
 *     post: (url: string, data: object) => Promise<unknown>,
 * }}
 */
const fetcher = CLWrap(_worker)

export default (post_id, comment_parent = 0) => ({
	comment_author: '',
	comment_author_email: '',
	comment_author_url: '',
	comment_content: '',
	comment_score: '',
	post_id,
	comment_parent,

	should_clean: false,
	should_reload: false,

	success: false,
	success_message: '',

	init() {
		this.should_clean = this.$root.hasAttribute('data-clean')
		this.should_reload = this.$root.hasAttribute('data-reload')
		this.success_message = this.$root.hasAttribute('data-onsuccess') && this.$root.getAttribute('data-onsuccess')
	},

	onSubmit(e) {
		// Do not really submit form
		e.preventDefault()

		// Create fetch request in background via fetch-worker
		fetcher
			.post(ajaxUrl('create_post_comment'), {
				comment_author: this.comment_author,
				comment_author_email: this.comment_author_email,
				comment_author_url: this.comment_author_url,
				comment_content: this.comment_content,
				comment_score: this.comment_score,
				post_id: this.post_id,
				comment_parent: this.comment_parent,
			})
			.then((response) => {
				if (response.success) {
					if (this.should_reload) {
						this.$root.dispatchEvent(new CustomEvent('brendakookt:refresh-comments'))
					}
					this.clean()
					this.success = true
				}
			})
			.catch((error) => {
				this.success = false
				console.error(error)
			})
	},

	// set comment_ fields back to ''
	clean() {
		if (this.should_clean) {
			this.comment_author = ''
			this.comment_author_email = ''
			this.comment_author_url = ''
			this.comment_content = ''
			this.comment_score = ''
		}
	},
})
